import React, { useState, useEffect } from 'react';
import Contents from './Contents'
import axios from 'axios';
import './Home.css';
import { getAuth } from 'firebase/auth';
import { getDatabase, ref, onValue, push, set } from 'firebase/database';
import FilterModal from './FilterModal';
import MyInfo from './MyInfo';
import VideoAnalysis from './VideoAnalysis';
import Navbar from './Navbar'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// import YoutubeReporting from './YoutubeReporting';

function Home() {
  //툴팁
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      할당량 40%를 사용하지만<br/>
      엄청난 검색량을 보여줍니다
    </Tooltip>
  );

  //정렬기능
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [sortField2, setSortField2] = useState('contribution');
  const [sortDirection2, setSortDirection2] = useState('desc');

  const sortVideos = (videos, field, direction) => {
    const sortedVideos = videos.slice(); // 기존 배열을 변경하지 않고 복사하여 정렬합니다.
    
    if (field) {
      sortedVideos.sort((a, b) => {
        if (direction === 'asc') {
          return a[field] > b[field] ? 1 : a[field] < b[field] ? -1 : 0;
        } else {
          return a[field] < b[field] ? 1 : a[field] > b[field] ? -1 : 0;
        }
      });
    }
    
    return sortedVideos;
  };

  const sortVideos2 = (videos, field2, direction2) => {
    const sortedVideos2 = videos.slice(); // 기존 배열을 변경하지 않고 복사하여 정렬합니다.
    
    if (field2) {
      sortedVideos2.sort((a, b) => {
        if (direction2 === 'asc') {
          return a[field2] > b[field2] ? 1 : a[field2] < b[field2] ? -1 : 0;
        } else {
          return a[field2] < b[field2] ? 1 : a[field2] > b[field2] ? -1 : 0;
        }
      });
    }
    
    return sortedVideos2;
  };
  



  const [query, setQuery] = useState('');
  const [videosByTitle, setVideosByTitle] = useState([]);
  const [videosByRelevance, setVideosByRelevance] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [myInfo, setMyInfo] = useState('');
  // 필요한 상태(state)를 정의합니다.
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filteredMinSubscribers, setFilteredMinSubscribers] = useState('');
  const [filteredMaxSubscribers, setFilteredMaxSubscribers] = useState('');
  const [filteredShowShots, setFilteredShowShots] = useState(true);
  // 슈퍼서치
  const [superSearch, setSuperSearch] = useState(false);
  // 슈퍼서치검열

  //경고문
  const handleClick = () => {
    alert('구현중입니다');
  };

  //마이페이지 모달
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const handleModalClose2 = () => {
    setIsModalOpen2(false);
  };
  const handleEditButtonClick2 = () => {
    setIsModalOpen2(true);
  };
  //구독자, 조회수 정렬
  

  //영상분석 모달
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const handleModalClose3 = () => {
    setIsModalOpen3(false);
  };
  const handleEditButtonClick3 = () => {
    setIsModalOpen3(true);
  };

    //키워드 분석 모달
    const [isModalOpen4, setIsModalOpen4] = useState(false);
    const handleModalClose4 = () => {
      setIsModalOpen4(false);
    };
    const handleEditButtonClick4 = () => {
      setIsModalOpen4(true);
    };

        //키워드 분석 모달
        const [isModalOpen5, setIsModalOpen5] = useState(false);
        const handleModalClose5 = () => {
          setIsModalOpen5(false);
        };
        const handleEditButtonClick5 = () => {
          setIsModalOpen5(true);
        };

  
  // 필요한 함수(onApply, onReset, onClose)를 정의합니다.
  const handleFilterApply = (minSubscribers, maxSubscribers, showShots) => {
    setFilteredMinSubscribers(minSubscribers);
    setFilteredMaxSubscribers(maxSubscribers);
    setFilteredShowShots(showShots);
  
    const filteredVideosByTitle = videosByTitle
      .filter((video) => {
        let passed = true;
        if (minSubscribers && video.subscribers < parseInt(minSubscribers)) {
          passed = false;
        }
        if (maxSubscribers && video.subscribers > parseInt(maxSubscribers)) {
          passed = false;
        }
        if (showShots && video.duration && video.duration > 0) {
          passed = false;
        }
        return passed;
      })
      .sort((a, b) => b.contribution - a.contribution)
      .slice(0, 50);
  
    const filteredVideosByRelevance = videosByRelevance
      .filter((video) => {
        let passed = true;
        if (minSubscribers && video.subscribers < parseInt(minSubscribers)) {
          passed = false;
        }
        if (maxSubscribers && video.subscribers > parseInt(maxSubscribers)) {
          passed = false;
        }
        if (showShots && video.duration && video.duration > 0) {
          passed = false;
        }
        return passed;
      })
      .sort((a, b) => b.contribution - a.contribution)
      .slice(0, 50);
  
    setVideosByTitle(filteredVideosByTitle);
    setVideosByRelevance(filteredVideosByRelevance);
  };
  
  
  const handleFilterReset = () => {
    setFilteredMinSubscribers('');
    setFilteredMaxSubscribers('');
    setFilteredShowShots(true);

    setSortField(null);
    setSortDirection('asc');
    setSortField2('contribution');
    setSortDirection2('desc');

  };
  
  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  
  const handleFilterButtonClick = () => {
    setIsModalOpen(true);
  };
  
  // 로그인한 사용자 uid 가져오기
  const { currentUser } = getAuth();
  const uid = currentUser ? currentUser.uid : '';

  useEffect(() => {
    if (uid) {
      // Firebase Realtime Database에서 사용자의 MyInfo 가져오기
      const db = getDatabase();
      const myInfoRef = ref(db, `users/${uid}/myInfo`);
      onValue(myInfoRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setMyInfo(data.info);
        }
      });
    }
  }, [uid]);




  const searchVideos = async (query, order, superSearch) => {
  setLoading(true);
  try {
    const youtube = axios.create({
      baseURL: 'https://www.googleapis.com/youtube/v3',
      params: {
        key: myInfo,
      },
    });
    const params = {
      q: query,
      type: 'video',
      part: 'snippet',
      maxResults: superSearch ? 200 : 40,
      order: order,
      publishedAfter: '2021-01-01T00:00:00Z',
    };
    let videos = [];
    let prevVideoIds = []; // 이전 페이지에서 가져온 동영상의 videoId를 저장하는 배열

    const fetchVideoDetails = async (videoId) => {
      const videoResponse = await youtube.get('/videos', {
        params: {
          part: 'snippet,statistics',
          id: videoId,
        },
      });

      const videoInfo = videoResponse.data.items[0];

      const videoTitle = videoInfo.snippet.title;
      const videoUrl = `https://www.youtube.com/watch?v=${videoId}`;
      const thumbnail = videoInfo.snippet.thumbnails.default.url;

      let viewCount = 0;
      let subscriberCount = 0;

      if (videoInfo.statistics) {
        viewCount = parseInt(videoInfo.statistics.viewCount);
        if (videoInfo.statistics.subscriberCount) {
          subscriberCount = parseInt(videoInfo.statistics.subscriberCount);
        } else {
          const channelResponse = await youtube.get('/channels', {
            params: {
              part: 'snippet,statistics',
              id: videoInfo.snippet.channelId,
            },
          });

          const channelInfo = channelResponse.data.items[0];
          subscriberCount = parseInt(channelInfo.statistics.subscriberCount);
        }
      }

      const contribution = subscriberCount === 0 ? viewCount : viewCount / subscriberCount;

      const uploadDate = videoInfo.snippet.publishedAt;

      return {
        videoId: videoId,
        title: videoTitle,
        subscribers: subscriberCount,
        views: viewCount,
        contribution: contribution,
        url: videoUrl,
        thumbnail: thumbnail,
        uploadDate: uploadDate,
      };
    };

    if (superSearch) {
      let nextPageToken = null;
      do {
        const response = await youtube.get('/search', {
          params: {
            ...params,
            pageToken: nextPageToken,
          },
        });
        const videoIds = response.data.items.map((item) => item.id.videoId);
        const newVideoIds = videoIds.filter(videoId => !prevVideoIds.includes(videoId));
        prevVideoIds = [...prevVideoIds, ...videoIds];

        const videosForPage = await Promise.all(newVideoIds.map(fetchVideoDetails));
        videos = [...videos, ...videosForPage];
        nextPageToken = response.data.nextPageToken;
      } while (nextPageToken);
    } else {
      const response = await youtube.get('/search', { params });
      const videoIds = response.data.items.map((item) => item.id.videoId);
      const videoDetails = await Promise.all(videoIds.map(fetchVideoDetails));
      videos = videoDetails;
    }

    let filteredVideos = videos; // 기본적으로 중복 제거하지 않은 전체 동영상 리스트를 사용함
    if (order === 'title') {
      filteredVideos = videos
        .filter((video) => {
          let passed = true;
          if (filteredMinSubscribers && video.subscribers < parseInt(filteredMinSubscribers)) {
            passed = false;
          }
          if (filteredMaxSubscribers && video.subscribers > parseInt(filteredMaxSubscribers)) {
            passed = false;
          }
          if (filteredShowShots && video.duration && video.duration > 0) {
            passed = false;
          }
          return passed;
        })
        .sort((a, b) => b.contribution - a.contribution)
        .slice(0, 50);
    }

    // 중복 제거된 동영상 리스트를 만듦
    const uniqueVideos = Array.from(new Set(filteredVideos.map(video => video.videoId))).map(videoId => {
      return filteredVideos.find(video => video.videoId === videoId);
    });

    if (order === 'title') {
      setVideosByTitle(uniqueVideos);
    } else {
      setVideosByRelevance(uniqueVideos);
    }
    setLoading(false);
  } catch (error) {
    setError('Error: There was a problem with the search.');
    setLoading(false);
  }
};

  

  
  
           
  
  
  
  
  
  
const handleScrapButtonClick = async (video) => {
try {
const db = getDatabase();
const videoRef = push(ref(db, `users/${uid}/savedVideos`));
await set(videoRef, video);
console.log('스크랩 성공!');
} catch (error) {
console.error('스크랩 실패:', error);
}
};

const handleSearch = () => {
if (query !== '') {
searchVideos(query, 'title', superSearch);
searchVideos(query, 'relevance', superSearch);
}
};

const handleKeyPress = (event) => {
if (event.key === 'Enter') {
handleSearch();
}
};

const videos = videosByTitle.concat(videosByRelevance);

return (
<div className="home">
<button className="my-info-button" onClick={handleEditButtonClick2}>
  마이페이지
</button>
<button className="video-analysis-button" onClick={handleEditButtonClick3} >
    영상분석
  </button>
  <button className="keyword-analysis-button" onClick={handleEditButtonClick4} >
    키워드 분석
  </button>
  <button className="contents-analysis-button" onClick={handleEditButtonClick5}>
        컨텐츠 분석
      </button>
<div className="search-container">
  <div className='filter'>
    <h1>Htrend</h1>
  </div>
  <div className="search-bar">
  <OverlayTrigger
      placement="left"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
  <label>
  슈퍼서치:
  <input
    type="checkbox"
    checked={superSearch}
    onChange={(e) => setSuperSearch(e.target.checked)}
  />
</label>
</OverlayTrigger>
    <input
      type="text"
      placeholder="Keyword"
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      onKeyPress={handleKeyPress}
    />
    <button className="search-button" onClick={handleSearch}>
      검색
    </button>
    <button className="filter-button" onClick={handleFilterButtonClick}>
      필터
    </button>

  </div>
</div>
{loading && <p>Loading...</p>}
{error && <p>{error}</p>}
{videos.length > 0 && (
  <>
    <h2>Keyword Search</h2>
    <table>
      <thead>
  <tr>
    <th>Thumbnail</th>
    <th>Title</th>
    <th>
      Subscribers
      <button style={{ backgroundColor:"#3c3d3f" }} onClick={() => { setSortField('subscribers'); setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc') }}>
        {sortField === 'subscribers' ? (sortDirection === 'asc' ? '▼' : '▲') : '⇅'}
      </button>
    </th>
    <th>
      Views
      <button style={{ backgroundColor:"#3c3d3f" }} onClick={() => { setSortField('views'); setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc') }}>
        {sortField === 'views' ? (sortDirection === 'asc' ? '▼' : '▲') : '⇅'}
      </button>
    </th>
    <th>
      Date
      <button style={{ backgroundColor:"#3c3d3f" }} onClick={() => { setSortField('uploadDate'); setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc') }}>
        {sortField === 'uploadDate' ? (sortDirection === 'asc' ? '▼' : '▲') : '⇅'}
      </button>
    </th>
    <th>Scarp</th>
    {/* <th>기여도</th> */}
  </tr>
</thead>
<tbody>
{sortVideos(videosByTitle, sortField, sortDirection)
  .filter((video) => {
    let passed = true;
    if (filteredMinSubscribers && video.subscribers < parseInt(filteredMinSubscribers)) {
      passed = false;
    }
    if (filteredMaxSubscribers && video.subscribers > parseInt(filteredMaxSubscribers)) {
      passed = false;
    }
    if (filteredShowShots && video.duration && video.duration > 0) {
      passed = false;
    }
    return passed;
  })
  .slice(0, 50)
  .map((video, index) => (
  <tr key={index}>
    <td className="video-thumbnail" >
      <a href={video.url} target="_blank" rel="noopener noreferrer">
        <img src={video.thumbnail} alt={video.title} style={{ width: "150px", height: "80px" }} />
      </a>
    </td>
    <td className="video-title">
      {video.title}
    </td>
    <td>{video.subscribers.toLocaleString()}</td>
    <td>{video.views.toLocaleString()}</td>
    <td>{video.uploadDate.substring(0, 10)}</td>
    {/* <td>{video.contribution.toFixed(2)}</td> */}
    <td>        
      <button className="scrap-button" onClick={() => handleScrapButtonClick(video)}>
        스크랩
      </button>
    </td>
  </tr>
))}
      </tbody>
    </table>
    <h2>Relevance Search</h2>
    <table>
    <thead>
  <tr>
    <th>Thumbnail</th>
    <th>Title</th>
    <th>
      Subscribers
      <button style={{ backgroundColor:"#3c3d3f" }} onClick={() => { setSortField2('subscribers'); setSortDirection2(sortDirection2 === 'asc' ? 'desc' : 'asc') }}>
        {sortField2 === 'subscribers' ? (sortDirection2 === 'asc' ? '▼' : '▲') : '⇅'}
      </button>
    </th>
    <th>
      Views
      <button style={{ backgroundColor:"#3c3d3f" }} onClick={() => { setSortField2('views'); setSortDirection2(sortDirection2 === 'asc' ? 'desc' : 'asc') }}>
        {sortField2 === 'views' ? (sortDirection2 === 'asc' ? '▼' : '▲') : '⇅'}
      </button>
    </th>
    <th>
      Date
      <button style={{ backgroundColor:"#3c3d3f" }} onClick={() => { setSortField2('uploadDate'); setSortDirection2(sortDirection2 === 'asc' ? 'desc' : 'asc') }}>
        {sortField2 === 'uploadDate' ? (sortDirection2 === 'asc' ? '▼' : '▲') : '⇅'}
      </button>
    </th>
    <th>Scarp</th>
    {/* <th>기여도</th> */}
  </tr>
</thead>
    <tbody>
    {sortVideos2(videosByRelevance, sortField2, sortDirection2)
  .filter((video) => {
    let passed = true;
    if (filteredMinSubscribers && video.subscribers < parseInt(filteredMinSubscribers)) {
      passed = false;
    }
    if (filteredMaxSubscribers && video.subscribers > parseInt(filteredMaxSubscribers)) {
      passed = false;
    }
    if (filteredShowShots && video.duration && video.duration > 0) {
      passed = false;
    }
    return passed;
  })
  .slice(0, 50)
  .map((video, index) => (
    <tr key={index}>
      <td className="video-thumbnail">
        <a href={video.url} target="_blank" rel="noopener noreferrer">
          <img src={video.thumbnail} alt={video.title} style={{ width: "150px", height: "80px" }} />
        </a>
      </td>
      <td className="video-title">
        {video.title}
      </td>
      <td>{video.subscribers.toLocaleString()}</td>
      <td>{video.views.toLocaleString()}</td>
      <td>{video.uploadDate.substring(0, 10)}</td>
      {/* <td>{video.contribution.toFixed(2)}</td> */}
      <td>
        <button className="scrap-button" onClick={() => handleScrapButtonClick(video)}>
          스크랩
        </button>
      </td>
    </tr>
  ))}
    </tbody>
  </table>
</>
)}
<FilterModal 
 isOpen={isModalOpen} 
 onClose={handleModalClose} 
 onApply={handleFilterApply} 
 onReset={handleFilterReset} 
 filteredMinSubscribers={filteredMinSubscribers}
 filteredMaxSubscribers={filteredMaxSubscribers}
 filteredShowShots={filteredShowShots}
 sortField={sortField}
 sortDirection={sortDirection}
 sortField2={sortField2}
 sortDirection2={sortDirection2}
/>
<MyInfo
  isOpen2={isModalOpen2}
  onClose2={handleModalClose2}
/>
<VideoAnalysis
  isOpen3={isModalOpen3}
  onClose3={handleModalClose3}
  apiKey={myInfo}
/>
<Navbar
  isOpen4={isModalOpen4}
  onClose4={handleModalClose4}
  query={query}
/>

<Contents
  isOpen5={isModalOpen5}
  onClose5={handleModalClose5}
  apiKey={myInfo}
/>

{/* <YoutubeReporting/> */}

</div>
);
}
export default Home;
